module.exports = __webpack_public_path__ + "img/index_index_mobile_logo.0028993e.png";